import { apiClient } from '@/api/client';
import type {
  ApiSuccessResponse,
  MarkAllNotificationsReadResponse,
  NotificationCenterItemDto,
  NotificationCenterListQuery,
  NotificationUnreadCountDto,
} from '@invento/shared';

type Envelope<T> = ApiSuccessResponse<T>;

const compactParams = (
  params?: NotificationCenterListQuery,
): NotificationCenterListQuery | undefined => {
  if (!params) return undefined;
  const entries = Object.entries(params).filter(([, value]) => value !== undefined);
  return entries.length > 0 ? Object.fromEntries(entries) as NotificationCenterListQuery : undefined;
};

export const notificationsService = {
  async list(params?: NotificationCenterListQuery): Promise<Envelope<NotificationCenterItemDto[]>> {
    const response = await apiClient.get<Envelope<NotificationCenterItemDto[]>>('/notifications', {
      params: compactParams(params),
    });
    return response.data;
  },

  async getUnreadCount(): Promise<Envelope<NotificationUnreadCountDto>> {
    const response = await apiClient.get<Envelope<NotificationUnreadCountDto>>('/notifications/unread-count');
    return response.data;
  },

  async markRead(notificationId: string): Promise<Envelope<NotificationCenterItemDto>> {
    const response = await apiClient.post<Envelope<NotificationCenterItemDto>>(
      `/notifications/${notificationId}/read`,
    );
    return response.data;
  },

  async markAllRead(): Promise<Envelope<MarkAllNotificationsReadResponse>> {
    const response = await apiClient.post<Envelope<MarkAllNotificationsReadResponse>>('/notifications/read-all');
    return response.data;
  },

  async archive(notificationId: string): Promise<Envelope<NotificationCenterItemDto>> {
    const response = await apiClient.post<Envelope<NotificationCenterItemDto>>(
      `/notifications/${notificationId}/archive`,
    );
    return response.data;
  },
};
